import type { QuotaKey, QuotaUsage } from '@simplemon/lib';
import { publicErrorMessage, readJsonOrThrow } from './error';

interface QuotaListResponse {
  quotas: QuotaUsage[];
}

export const quotasApi = {
  async list(): Promise<QuotaUsage[]> {
    const response = await fetch('/api/quotas', {
      credentials: 'include',
    });

    const data = await readJsonOrThrow(response, 'Failed to fetch quotas');
    if (!response.ok) {
      throw new Error(publicErrorMessage(data, 'Failed to fetch quotas'));
    }

    return (data as QuotaListResponse).quotas;
  },

  async get(key: QuotaKey): Promise<QuotaUsage> {
    const response = await fetch(`/api/quotas/${key}`, {
      credentials: 'include',
    });

    const data = await readJsonOrThrow(response, 'Failed to fetch quota');
    if (!response.ok) {
      throw new Error(publicErrorMessage(data, 'Failed to fetch quota'));
    }

    return data as QuotaUsage;
  },
};
